/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdWrapper
 */
export interface IdWrapper {
    /**
     * 
     * @type {string}
     * @memberof IdWrapper
     */
    id: string;
}

export function IdWrapperFromJSON(json: any): IdWrapper {
    return IdWrapperFromJSONTyped(json, false);
}

export function IdWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function IdWrapperToJSON(value?: IdWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


